import { useState, useRef, useEffect } from "react";
import { PiUserCircleDuotone } from "react-icons/pi";
import {
  RiMenuFoldLine,
  RiMenuUnfoldLine,
  RiLogoutBoxLine,
} from "react-icons/ri";
import { FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";

const AuthNavbar = ({ sidebarOpen, setSidebarOpen }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const { admin, logoutAdmin } = useAdminAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logoutAdmin();
    navigate("/admin/login");
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-[64px] bg-white border-b flex items-center justify-between px-2 z-50">
      {/* LEFT SECTION */}{" "}
      <div className="flex items-center gap-3">
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="text-2xl text-gray-700 hover:text-black cursor-ew-resize transition hover:bg-surfaceAccentLight px-3.5 py-3"
        >
          {sidebarOpen ? <RiMenuFoldLine /> : <RiMenuUnfoldLine />}{" "}
        </button>

        <img
          src="/logo.png"
          onClick={() => navigate(`/admin/dashboard`)}
          alt="logo"
          className="h-12 object-contain cursor-pointer"
        />
      </div>
      {/* RIGHT SECTION */}
      <div ref={dropdownRef} className="relative pr-2">
        {/* AVATAR BUTTON */}
        <button
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center justify-center h-12 w-12 border border-borderLight/50 bg-surfaceAccentLight/50 hover:bg-surfaceAccentLight hover:border-borderLight transition"
        >
          <PiUserCircleDuotone size={34} className="text-headingText" />
        </button>

        {/* DROPDOWN */}
        <div
          className={`absolute right-2 mt-2 w-56 bg-surfaceColor border border-borderLight shadow-lg overflow-hidden transition-all duration-200 ${
            dropdownOpen
              ? "opacity-100 translate-y-0 visible"
              : "opacity-0 -translate-y-2 invisible"
          }`}
        >
          {/* Profile Section */}
          <div className="px-4 py-3 border-b border-divider">
            <p className="text-sm font-semibold text-headingText">
              {admin?.name || "Admin"}
            </p>
            <p className="text-xs text-descriptionText">{admin?.email || ""}</p>
          </div>

          {/* Profile */}
          <button
            onClick={() => {
              navigate("/admin/profile");
              setDropdownOpen(false);
            }}
            className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-headingText hover:bg-surfaceAccentLight transition"
          >
            <FiUser size={18} className="text-descriptionText" />
            Profile
          </button>

          <div className="border-t border-divider" />

          {/* Logout */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-danger hover:bg-red-50 transition"
          >
            <RiLogoutBoxLine size={16} />
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default AuthNavbar;
